import React, { createContext, useEffect, useState } from 'react';

import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-cycle
import Header from './header';
import Footer from './footer';
import request, { USER_RIGHTS } from '../utils/request';

export const GlobalContext = createContext();

const Layout = ({ locale, children, profile }) => {
  const userName = profile
    ? `${profile.first_name} ${profile.last_name}`
    : undefined;
  const userRights = profile ? USER_RIGHTS[profile.role.name] : undefined;

  const [defectNotificationCount, setDefectNotificationCount] = useState(0);

  useEffect(() => {
    if (!profile) return;
    request
      .get('/defects/count')
      .then(res => {
        const {
          data: { notificationCount = '' }
        } = res;
        setDefectNotificationCount(notificationCount);
      })
      .catch(() => {});
  }, []);

  return (
    <GlobalContext.Provider
      value={{ defectNotificationCount, setDefectNotificationCount }}
    >
      <Header locale={locale} userName={userName} userRights={userRights} />
      <div className="layout-container">{children}</div>
      <Footer disclaimer={false} />
    </GlobalContext.Provider>
  );
};

Layout.propTypes = {
  locale: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  profile: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    role: PropTypes.shape({ name: PropTypes.string })
  }).isRequired
};

export default Layout;
